import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmOfferStatusState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmOfferStatusState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmOfferStatusSlice = createSlice({
  name: 'pmOfferStatus',
  initialState,
  reducers: {
    setPmOfferStatuses: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmOfferStatusesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmOfferStatusesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmOfferStatuses, setPmOfferStatusesLoading, setPmOfferStatusesError } = PmOfferStatusSlice.actions;

export default PmOfferStatusSlice.reducer;
